import { useQuery } from '@tanstack/react-query';

import { MultiFilterState } from '~/components/Common/Forms/OrderSearchForm';

import { AccommodationV2Scope, getPurchases } from '~/services/OrdersService';

export const ITEM_TYPE_ACCOMMODATION_V2 = 'accommodationV2';

export const accommodationV2PurchasesQueryKeys = {
  all: ['orders', 'accommodation-v2'] as const,
  list: (params: UseGetAccommodationV2PurchasesParams) => [...accommodationV2PurchasesQueryKeys.all, params] as const,
};

interface UseGetAccommodationV2PurchasesParams {
  brand: string;
  page: number;
  perPage: number;
  scope: AccommodationV2Scope;
  customerId?: string | null;
  filterField?: string | null;
  filterValue?: string | null;
  additionalFilter?: MultiFilterState | null;
  /** bumped on every submit so repeating an identical search still refetches */
  searchNonce: number;
}

export function useGetAccommodationV2Purchases(params: UseGetAccommodationV2PurchasesParams, enabled = true) {
  return useQuery({
    queryKey: accommodationV2PurchasesQueryKeys.list(params),
    queryFn: ({ signal }) =>
      getPurchases({
        page: params.page,
        per_page: params.perPage,
        brand: params.brand,
        customer_id: params.customerId ?? undefined,
        filterBy: params.filterField ?? undefined,
        filterValue: params.filterValue ?? undefined,
        additionalFilter: params.additionalFilter ?? undefined,
        item_type: ITEM_TYPE_ACCOMMODATION_V2,
        accommodationV2Scope: params.scope,
        signal,
      }) as Promise<{ result: Array<App.Order>; total: number }>,
    enabled: enabled && !!params.brand,
  });
}
